<app-new-offer-button
	[dealId]="dealId"
	[loanProductCategory]="loanProductCategory">
</app-new-offer-button>